import React from 'react'
import './skills.scss'
import {
   FaPython,
   FaHtml5,
   FaCss3,
   FaChrome,
   FaServer,
   FaFigma,
   FaBrain,
   FaWordpress,
} from 'react-icons/fa'
import { SiJavascript } from 'react-icons/si'

function Skills() {
   const languages = [
      {
         icon: <FaPython className="icon" />,
         label: 'Python',
      },
      {
         icon: <SiJavascript className="icon" />,
         label: 'Javascript',
      },
      {
         icon: <FaHtml5 className="icon" />,
         label: 'HTML5',
      },
      {
         icon: <FaCss3 className="icon" />,
         label: 'CSS3',
      },
      {
         icon: <FaWordpress className="icon" />,
         label: 'Wordpress',
      },
   ]

   const skills = [
      {
         icon: <FaChrome className="icon" />,
         label: 'Frontend',
         covered: [
            'Working with CSS frameworks',
            'Connecting to backend via APIs',
            'Frontend frameworks such as ReactJs, Vanilla JS',
            'Flask for web development',
            'Wordpress site development',
         ],
      },
      {
         icon: <FaServer className="icon" />,
         label: 'Backend',
         covered: [
            'Creating APIs',
            'Connecting to databases eg MongoDB, SQLlite, Postgress',
            'Working with Python (Flask) and Javascript (Node Js) ',
         ],
      },
      {
         icon: <FaFigma className="icon" />,
         label: 'Design',
         covered: [
            'Creating web app designs',
            'Working with SVGs and Images',
            'Creating prototypes',
            'Working with Figma and Adobe XD',
         ],
      },
      {
         icon: <FaBrain className="icon" />,
         label: 'Data Science',
         covered: [
            'Data Cleaning',
            'Creating data models',
            'Visualizing data',
            'Working with libraries like Sklearn, h2o',
            'Working with numpy and panda',
         ],
      },
   ]
   return (
      <div className="skills">
         <div className="skills__wrapper">
            <div className="skills__wrapper--languages">
               <h3>Skills</h3>
               <div className="skills__wrapper--languages-wrapper">
                  {languages.map((language, index) => (
                     <div key={index} className="item">
                        <span>{language.icon}</span>
                        <p>{language.label}</p>
                     </div>
                  ))}
               </div>
            </div>
            <div className="skills__wrapper--skills">
               {skills.map((skill, index) => (
                  <div className="skills__wrapper--skills-card" key={index}>
                     <span>{skill.icon}</span>
                     <h4>{skill.label}</h4>
                     <ul>
                        {skill.covered.map((cover, index) => (
                           <li key={index}>{cover}</li>
                        ))}
                     </ul>
                  </div>
               ))}
            </div>
         </div>
      </div>
   )
}

export default Skills
